import { useState } from "react";
import { runRecipe } from "../api";

type Props = { onSpawned: (jobId: string) => void };

const DEFAULT_REF = "recipes.rebalance@^1";
const DEFAULT_INPUTS = JSON.stringify(
  {
    expected_returns: { AAPL: 0.05, MSFT: 0.03 },
    portfolio: { holdings: { AAPL: 0.1, MSFT: -0.05 } },
  },
  null,
  2,
);

export function RecipeRunner({ onSpawned }: Props) {
  const [recipeRef, setRecipeRef] = useState(DEFAULT_REF);
  const [inputsJson, setInputsJson] = useState(DEFAULT_INPUTS);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit() {
    setError(null);
    let inputs: Record<string, unknown>;
    try {
      inputs = JSON.parse(inputsJson);
    } catch (e) {
      setError(`Inputs JSON parse error: ${e}`);
      return;
    }
    setBusy(true);
    try {
      const { job_id } = await runRecipe({ recipe_ref: recipeRef, inputs });
      onSpawned(job_id);
    } catch (e) {
      setError(String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card">
      <div className="row">
        <div>
          <label>recipe ref</label>
          <input
            type="text"
            value={recipeRef}
            onChange={(e) => setRecipeRef(e.target.value)}
            placeholder="recipes.rebalance@^1"
          />
        </div>
      </div>
      <div style={{ marginTop: 12 }}>
        <label>inputs (JSON)</label>
        <textarea value={inputsJson} onChange={(e) => setInputsJson(e.target.value)} />
      </div>
      {error && <div className="status-error" style={{ marginTop: 8 }}>{error}</div>}
      <div style={{ marginTop: 12 }}>
        <button disabled={busy || !recipeRef.trim()} onClick={submit}>
          {busy ? "Spawning…" : "Run recipe"}
        </button>
      </div>
    </div>
  );
}
